<template>
  <div class="table-responsive">
    <table class="table table-bordered align-middle hos-table">
      <thead>
        <tr>
          <th class="text-start">{{ groupBy === 'category' ? 'Category' : 'Item' }}</th>
          <th class="text-end">Order</th>
          <th class="text-end">Production</th>
          <th class="text-end">Delivery</th>
          <th class="text-end">Stock In Hand</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="index">
          <td class="text-start hos-name-cell">{{ row.name }}</td>
          <td class="text-end">
            <div class="hos-metric-qty">{{ onlyCommaFormat(row.order_qty) }}</div>
            <div class="hos-metric-value">{{ commaFormat(row.order_value) }}</div>
          </td>
          <td class="text-end">
            <div class="hos-metric-qty">{{ onlyCommaFormat(row.production_qty) }}</div>
            <div class="hos-metric-value">{{ commaFormat(row.production_value) }}</div>
          </td>
          <td class="text-end">
            <div class="hos-metric-qty">{{ onlyCommaFormat(row.delivery_qty) }}</div>
            <div class="hos-metric-value">{{ commaFormat(row.delivery_value) }}</div>
          </td>
          <td class="text-end">
            <div class="hos-metric-qty hos-metric-stock">{{ onlyCommaFormat(row.stock_in_hand_qty) }}</div>
            <div class="hos-metric-value">{{ commaFormat(row.stock_in_hand_value) }}</div>
          </td>
        </tr>
        <tr v-if="! rows || ! rows.length">
          <td colspan="5" class="hos-empty-row">No data found for the selected filters.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import figureFormatter from "@/services/utils/figureFormatter";

const { commaFormat, onlyCommaFormat } = figureFormatter()

defineProps({
  rows: Array,
  groupBy: String
})
</script>

<style scoped>
.hos-table {
  font-size: 12px;
}

.hos-table thead th {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8a8894;
  background-color: #f8f9fb;
}

.hos-name-cell {
  font-size: 13px;
  font-weight: 600;
  color: #2b2b2b;
}

.hos-metric-qty {
  font-size: 13px;
  font-weight: 700;
  color: #2b2b2b;
  line-height: 1.3;
}

.hos-metric-value {
  font-size: 11px;
  font-weight: 500;
  color: #9a98a3;
  line-height: 1.3;
}

.hos-metric-stock {
  color: #16a085;
}

.hos-empty-row {
  text-align: center;
  color: #9a98a3;
  font-size: 12px;
  padding: 28px 0;
}
</style>
